<template>
  <div class="box-wrap">
    <address-list-search
      v-if="isAddressOpen"
      @close="controlAddressModal()"
      @selectAddress="selectAddress($event)"
      :pinStatus="pinStatus"
    ></address-list-search>
    <commonPopup
      v-if="isPopupOpen"
      @close="isPopupOpen = false"
      :msg="popupMsg"
    />
    <card
      :class="{
        invalid: invalidPinIdx === idx && storePinInvalidate.includes(idx)
      }"
    >
      <div class="box__title">
        <div>{{ mixinsPinTitle(idx, getPins.length) }}</div>
        <div class="box__title--utils">
          <div
            class="box__title--add"
            @click="updateAddToBookmark(!getPins[idx].addToBookmark, idx)"
          >
            <svg
              :class="{ active: getPins[idx].addToBookmark }"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="10" cy="10" r="10" fill="" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M8.68293 14L5 10.2836L5.93858 9.45016L8.67457 12.2113L14.721 6L15.6667 6.82614L8.68293 14Z"
                fill="white"
              />
            </svg>
            {{ pinStatus === "departure" ? "출발지" : "도착지" }} 저장
          </div>
          <img
            style="cursor: pointer"
            v-if="pinStatus === 'waypoint'"
            @click="$emit('deleteWaypoint'), $emit('calculator')"
            src="@/assets/img/order/bi_x.svg"
          />
        </div>
      </div>
      <div class="input">
        <div class="address" v-if="bookmarkList.length > 0">
          <div
            @click.stop="selectAddress(list)"
            class="address__name"
            v-for="(list, idx) in bookmarkList"
          >
            <span>{{ list.name }}</span>
            <img
              @click.stop="
                $emit('deleteAddress', list, pinStatus === 'departure' ? 1 : 2)
              "
              src="@/assets/img/order/ic_order_remove.svg"
            />
          </div>
        </div>
        <div class="pin">
          <input
            style="cursor: pointer"
            placeholder="주소 검색"
            v-model="fullAddress"
            readonly
            @click="isAddressOpen = true"
          />
          <div class="pin__detail">
            <input
              type="text"
              :value="getPins[idx].name"
              @input="updatePinName({ idx: idx, name: $event.target.value })"
              placeholder="이름/상호"
            />
            <input
              type="text"
              v-onlyNumber
              :value="getPins[idx].phoneNumber"
              @input="
                updatePhoneNumber({
                  idx: idx,
                  phoneNumber: replaceString($event.target.value)
                })
              "
              placeholder="연락처"
            />
          </div>
          <input
            class="desktop"
            :value="getPins[idx].pinMemo"
            @input="updatePinMemo($event.target.value, idx)"
            :placeholder="`${mixinsPinTitle(
              idx,
              getPins.length
            )} 메모 (예: 공동현관 비밀번호 1234, 건물 주차 불가)`"
            maxlength="200"
          />
          <input
            class="mobile"
            :value="getPins[idx].pinMemo"
            @input="updatePinMemo($event.target.value, idx)"
            :placeholder="`${mixinsPinTitle(
              idx,
              getPins.length
            )} 메모 (예: 공동현관 비밀번호 1234)`"
            maxlength="200"
          />
        </div>
      </div>
    </card>
  </div>
</template>
<script>
import card from "@/components/common/card.vue";
import commonPopup from "@/components/modal/commonPopup/layout.vue";
import "vue2-datepicker/locale/ko";
import AddressListSearch from "@/components/modal/AddressListSearch/layout.vue";
import mixinOrder from "@/mixins/mixinOrder";
import mixinOrderValidate from "@/mixins/mixinOrderValidate";
import mixinFilter from "@/mixins/mixinFilter";
export default {
  mixins: [mixinOrder, mixinOrderValidate, mixinFilter],
  props: ["idx", "bookmarkList", "invalidPinIdx", "storePinInvalidate"],
  components: {
    card,
    commonPopup,
    AddressListSearch
  },
  data() {
    return {
      isAddressOpen: false,
      isPopupOpen: false,
      popupMsg: ""
    };
  },

  computed: {
    pinStatus() {
      if (this.idx === this.getPins.length - 1) {
        return "destination";
      } else if (this.idx === 0) {
        return "departure";
      } else {
        return "waypoint";
      }
    },

    memoPlaceholder() {
      if (this.idx === this.getPins.length - 1) {
        return "도착지 메모 (예: 공동현관 비밀번호 1234, 건물 주차 불가)";
      } else if (this.idx === 0) {
        return "출발지 메모 (예: 공동현관 비밀번호 1234, 건물 주차 불가)";
      } else {
        return `경유지${this.idx} 메모 (예: 공동현관 비밀번호 1234, 건물 주차 불가)`;
      }
    },

    fullAddress() {
      if (this.getPins[this.idx].jibunAddress) {
        return (
          this.getPins[this.idx].jibunAddress +
          " " +
          this.getPins[this.idx].detailAddress
        );
      }
      return "";
    }
  },
  methods: {
    controlAddressModal() {
      this.isAddressOpen = false;
      this.$emit("getBookmarkAddress"); //모달 닫을 시 주소정보 다시 불러옴
    },

    getLongNameByType(list) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].types.includes("DONGMYUN")) {
          return list[i].longName;
        }
      }
      return null;
    },

    selectAddress(addr) {
      const payload = {
        idx: this.idx,
        name: addr.name ?? this.getPins[this.idx].name,
        phoneNumber: addr.phoneNumber ?? this.getPins[this.idx].phoneNumber,
        jibunAddress: addr.jibunAddress,
        detailAddress: addr.detailAddress ?? "",
        dongName: addr.dongName ?? this.getLongNameByType(addr.addressElements),
        roadAddress: addr.roadAddress ?? "",
        coords: addr.coords
          ? [parseFloat(addr.coords[0]), parseFloat(addr.coords[1])]
          : [parseFloat(addr.y), parseFloat(addr.x)],
        addressElements: addr.addressElements ?? ""
      };
      this.updatePinFromModal(payload);
      if (this.checkCoords()) {
        const resetPin = {
          idx: this.idx,
          name: addr.name ?? this.getPins[this.idx].name,
          phoneNumber: addr.phoneNumber ?? this.getPins[this.idx].phoneNumber,
          jibunAddress: "",
          detailAddress: addr.detailAddress ?? "",
          dongName: "",
          roadAddress: addr.roadAddress ?? "",
          coords: ""
        };
        this.updatePinFromModal(resetPin);
        this.popupMsg = "출발지와 도착지의 주소가 같습니다.";
        return (this.isPopupOpen = true);
      }
      this.$emit("calculator");
    },

    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    replaceString(val) {
      const value = val.replace(/[^0-9]/g, "");
      return value;
    }
  }
};
</script>
<style src="./layout.css" scoped></style>
<style src="@/assets/css/newGlobal.css" scoped></style>
